'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  myMessage: _propTypes2.default.bool,
  type: _propTypes2.default.string,
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  createdAt: _propTypes2.default.node.isRequired,
  edited: _propTypes2.default.node,
  collapsed: _propTypes2.default.bool,
  fontSize: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};

var defaultProps = {
  myMessage: false,
  type: 'text',
  style: {},
  edited: null,
  collapsed: false,
  fontSize: 'small'
};

var MessageTime = function MessageTime(_ref) {
  var myMessage = _ref.myMessage,
      type = _ref.type,
      style = _ref.style,
      createdAt = _ref.createdAt,
      edited = _ref.edited,
      collapsed = _ref.collapsed,
      fontSize = _ref.fontSize;
  return _react2.default.createElement(
    'span',
    { style: _getStyles2.default.root(myMessage, type, collapsed, fontSize, style) },
    edited ? _react2.default.createElement(
      'span',
      { style: _styles2.default.edited },
      edited
    ) : null,
    _react2.default.createElement(
      'span',
      null,
      createdAt
    )
  );
};

MessageTime.propTypes = propTypes;
MessageTime.defaultProps = defaultProps;

exports.default = MessageTime;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message/message-time/index.js
// module id = 63
// module chunks = 0